import { useCallback, useEffect, useState } from 'react';
import { stockyApi } from '../components/misc/StockyApi';

const initialState = {
  accounts: [],
  hasAccounts: null,
  hasListings: null,
  isLoading: true,
  error: null,
};

export const useFirstRunOnboarding = (authUser) => {
  const [state, setState] = useState(initialState);

  const loadOnboardingState = useCallback(async () => {
    if (!authUser?.accessToken) {
      setState({ ...initialState, isLoading: false });
      return;
    }

    setState((previous) => ({ ...previous, isLoading: true, error: null }));

    let accounts;
    try {
      const accountsResponse = await stockyApi.getSellers(authUser);
      accounts = Array.isArray(accountsResponse?.data) ? accountsResponse.data : [];
    } catch (error) {
      console.error('Error loading connected accounts for onboarding:', error);
      setState({
        ...initialState,
        isLoading: false,
        error: 'No pudimos verificar tus cuentas conectadas.',
      });
      return;
    }

    if (accounts.length === 0) {
      setState({
        accounts,
        hasAccounts: false,
        hasListings: false,
        isLoading: false,
        error: null,
      });
      return;
    }

    try {
      const summaryResponse = await stockyApi.getItemsSummary(authUser);
      setState({
        accounts,
        hasAccounts: true,
        hasListings: summaryResponse?.data?.hasListings === true,
        isLoading: false,
        error: null,
      });
    } catch (error) {
      console.error('Error loading publication state for onboarding:', error);
      setState({
        accounts,
        hasAccounts: true,
        hasListings: null,
        isLoading: false,
        error: 'La cuenta está conectada, pero no pudimos verificar sus publicaciones.',
      });
    }
  }, [authUser]);

  useEffect(() => {
    loadOnboardingState();
  }, [loadOnboardingState]);

  return {
    ...state,
    retry: loadOnboardingState,
  };
};
